import { render, staticRenderFns } from "./dating.vue?vue&type=template&id=47be54bd&scoped=true&"
import script from "./dating.vue?vue&type=script&lang=js&"
export * from "./dating.vue?vue&type=script&lang=js&"
import style0 from "./dating.vue?vue&type=style&index=0&id=47be54bd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47be54bd",
  null
  
)

export default component.exports